module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._v("\n        Search By\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(this.$store.state.user.type == 'admin') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "branch_id",
      "label": "name",
      "options": _vm.branches,
      "placeholder": "Select Branch"
    },
    on: {
      "input": function($event) {
        return _vm.getBranchWiseCollectionCenter(_vm.branch, _vm.withChangeFilter = true)
      }
    },
    model: {
      value: (_vm.branch),
      callback: function($$v) {
        _vm.branch = $$v
      },
      expression: "branch"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canAccess('collection-center-create')) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Group")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "collection_center_id",
      "label": "name",
      "options": _vm.colCenters,
      "placeholder": "Select Group",
      "required": ""
    },
    on: {
      "input": _vm.getRecordByCollectionCenter
    },
    model: {
      value: (_vm.collectionCenter),
      callback: function($$v) {
        _vm.collectionCenter = $$v
      },
      expression: "collectionCenter"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        return _vm.printViewDisbursementByCollectionCenter(_vm.status = 'pending')
      }
    }
  }, [_vm._v("Get Print")])])])])]), _vm._v(" "), (_vm.canAccess('loan-disbursement-view-any')) ? _c('div', {
    staticClass: "info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Group Loan List")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [(_vm.canAccess('loan-disbursement-create-loan')) ? _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.newModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add New\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('label', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.per_page),
      expression: "per_page"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "name": "per_page",
      "aria-controls": "example1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.per_page = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeFilter()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "input-group pull-right input-group-sm",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table_search),
      expression: "table_search"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "text",
      "name": "table_search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.table_search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeFilter()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.table_search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s((index + _vm.pagination.from)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm.planName(row.plan)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm.planRecoveryType(row.plan)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.planAmt(row)))]), _vm._v(" "), _c('td', [(row.member) ? _c('button', {
      staticClass: "btn btn-xs btn-info",
      on: {
        "click": function($event) {
          return _vm.viewGroupMemberDetail(row.member_id)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(row.member.name) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.member) ? _c('span', [_vm._v(_vm._s(row.member.code))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.collection_center.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.agent) ? _c('span', [_vm._v(_vm._s(row.agent.name))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.branch.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.branch.branchCode))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.collection_center_leader.name))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-group"
    }, [(_vm.canAccess('loan-disbursement-update')) ? _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.status == 'pending'),
        expression: "row.status == 'pending'"
      }],
      staticClass: "btn btn-success btn-xs",
      on: {
        "click": function($event) {
          return _vm.editModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-delete')) ? _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.status == 'disbursed' || row.status == 'pending'),
        expression: "row.status == 'disbursed' || row.status == 'pending'"
      }],
      staticClass: "btn btn-danger btn-xs",
      on: {
        "click": function($event) {
          return _vm.deleteDisbursment(row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e(), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.filechargeStatus == 'exclude'),
        expression: "row.filechargeStatus == 'exclude'"
      }],
      staticClass: "btn btn-warning btn-xs",
      attrs: {
        "title": "File Charge"
      },
      on: {
        "click": function($event) {
          return _vm.fileChargeModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file"
    })]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.processingFeeStatus == 'exclude'),
        expression: "row.processingFeeStatus == 'exclude'"
      }],
      staticClass: "btn btn-warning btn-xs",
      attrs: {
        "title": "Processing Fee"
      },
      on: {
        "click": function($event) {
          return _vm.processingFeeModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-hourglass"
    })]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.insuranceFeeStatus == 'exclude'),
        expression: "row.insuranceFeeStatus == 'exclude'"
      }],
      staticClass: "btn btn-warning btn-xs",
      attrs: {
        "title": "Insurance Fee"
      },
      on: {
        "click": function($event) {
          return _vm.insuranceFeeModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user-md"
    })]), _vm._v(" "), (_vm.canAccess('loan-disbursement-create')) ? _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.status == 'pending'),
        expression: "row.status == 'pending'"
      }],
      staticClass: "btn btn-danger btn-xs",
      attrs: {
        "title": "Disbursed"
      },
      on: {
        "click": function($event) {
          return _vm.disbursmentModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-money"
    })]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-view')) ? _c('button', {
      staticClass: "btn btn-primary btn-xs",
      on: {
        "click": function($event) {
          return _vm.viewPrintModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-print"
    })]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-view')) ? _c('button', {
      staticClass: "btn btn-info btn-xs",
      attrs: {
        "title": "Dimand ProbeshnaryNote"
      },
      on: {
        "click": function($event) {
          return _vm.viewPrintDimandProbeshnoryNote(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sticky-note-o"
    })]) : _vm._e()])])])
  }), 0)])]), _vm._v(" "), (_vm.pagination.current_page > 0) ? _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\n            Showing " + _vm._s(_vm.pagination.from) + " to " + _vm._s(_vm.pagination.to) + " of " + _vm._s(_vm.pagination.total) + " entries\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm no-margin pull-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'first')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'prev')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), (_vm.pagination.current_page > 3) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 2) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page))])]), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 4)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 1))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 5)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 6)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 3))])]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 3)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 2)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 1)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'next')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'last')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("»")])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "newModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(2), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Create New Loan")]), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Update Loan")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.editMode ? _vm.updateLoan() : _vm.createLoan()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.userType === 'admin') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_id),
      expression: "form.branch_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_id'),
    },
    attrs: {
      "name": "branch_id",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getMemberAndGroupAndAgent]
    }
  }, [(!_vm.form.branch_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                              Select branch\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.branches), function(bra) {
    return _c('option', {
      key: bra.id,
      domProps: {
        "value": bra.id
      }
    }, [_vm._v("\n                              " + _vm._s(bra.name) + "\n                            ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "agent_id",
      "label": "name",
      "options": _vm.staffs,
      "placeholder": "Select Agent",
      "required": ""
    },
    on: {
      "input": _vm.getBranchAgent
    },
    model: {
      value: (_vm.staf),
      callback: function($$v) {
        _vm.staf = $$v
      },
      expression: "staf"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "agent_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Group ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "collection_center_id",
      "label": "name",
      "options": _vm.collectionCenters,
      "placeholder": "Select Group",
      "required": ""
    },
    on: {
      "input": _vm.getBranchCollectionCenter
    },
    model: {
      value: (_vm.colC),
      callback: function($$v) {
        _vm.colC = $$v
      },
      expression: "colC"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "collection_center_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "center_leader_id",
      "label": "name",
      "options": _vm.groupMembers,
      "placeholder": "Select Group Leader",
      "required": ""
    },
    on: {
      "input": _vm.getCenterLeader
    },
    model: {
      value: (_vm.centerLeader),
      callback: function($$v) {
        _vm.centerLeader = $$v
      },
      expression: "centerLeader"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "center_leader_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "purpose",
      "label": "name",
      "placeholder": "Select purpose",
      "options": _vm.purposes
    },
    on: {
      "input": _vm.getSelectPurpose
    },
    model: {
      value: (_vm.form.purpose),
      callback: function($$v) {
        _vm.$set(_vm.form, "purpose", $$v)
      },
      expression: "form.purpose"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "purpose_id"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.purpose_id),
      expression: "form.purpose_id"
    }],
    attrs: {
      "type": "hidden",
      "name": "purpose_id"
    },
    domProps: {
      "value": (_vm.form.purpose_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "purpose_id", $event.target.value)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.plan),
      expression: "form.plan"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('plan')
    },
    attrs: {
      "name": "plan",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "plan", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getSelectPlan]
    }
  }, [(!_vm.form.plan) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                              Select Plan\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.loanplans), function(loanpl) {
    return _c('option', {
      key: loanpl.id,
      domProps: {
        "value": loanpl
      }
    }, [_vm._v("\n                              " + _vm._s(loanpl.name) + "\n                            ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "plan_id"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.plan_id),
      expression: "form.plan_id"
    }],
    attrs: {
      "type": "hidden",
      "name": "plan_id"
    },
    domProps: {
      "value": (_vm.form.plan_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "plan_id", $event.target.value)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('description'),
    },
    attrs: {
      "type": "text",
      "name": "description",
      "placeholder": "Enter Description"
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "description"
    }
  })], 1), _vm._v(" "), (_vm.planTypeApplied == 'active') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.loanAmountType),
      expression: "form.loanAmountType"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('loanAmountType'),
    },
    attrs: {
      "name": "loanAmountType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "loanAmountType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeLoanAmountType]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Loan Amount Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "static"
    }
  }, [_vm._v("Static")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dynamic"
    }
  }, [_vm._v("Dynamic")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "loanAmountType"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "member_id",
      "label": "name",
      "options": _vm.groupMembers,
      "placeholder": "Select Member"
    },
    on: {
      "input": _vm.getBranchMember
    },
    model: {
      value: (_vm.mem),
      callback: function($$v) {
        _vm.mem = $$v
      },
      expression: "mem"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "member_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Guarantor ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "guarantor_id",
      "label": "name",
      "options": _vm.members,
      "placeholder": "Select Member"
    },
    on: {
      "input": _vm.getLoanGuarantor
    },
    model: {
      value: (_vm.guarantor),
      callback: function($$v) {
        _vm.guarantor = $$v
      },
      expression: "guarantor"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "guarantor_id"
    }
  })], 1), _vm._v(" "), (_vm.form.loanAmountType == 'dynamic') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.loanAmount),
      expression: "form.loanAmount"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('loanAmount'),
    },
    attrs: {
      "type": "text",
      "name": "loanAmount",
      "required": "",
      "placeholder": "Enter Customer loanAmount"
    },
    domProps: {
      "value": (_vm.form.loanAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "loanAmount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "loanAmount"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.loanAmountType == 'dynamic') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.fileCharge),
      expression: "form.fileCharge"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('fileCharge'),
    },
    attrs: {
      "type": "text",
      "name": "fileCharge",
      "required": "",
      "placeholder": "Enter Customer fileCharge"
    },
    domProps: {
      "value": (_vm.form.fileCharge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "fileCharge", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "fileCharge"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.loanAmountType == 'dynamic' && _vm.processingFeeType == 'fixed') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.processingFee),
      expression: "form.processingFee"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('processingFee'),
    },
    attrs: {
      "type": "text",
      "name": "processingFee",
      "required": "",
      "placeholder": "Enter Customer processingFee"
    },
    domProps: {
      "value": (_vm.form.processingFee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "processingFee", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "processingFee"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.loanAmountType == 'dynamic' && _vm.processingFeeType == 'percent') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.processingFee),
      expression: "form.processingFee"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('processingFeePer'),
    },
    attrs: {
      "type": "number",
      "step": ".01",
      "name": "processingFee",
      "placeholder": "Enter Customer processingFee",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.processingFee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "processingFee", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "processingFee"
    }
  })], 1) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                CREATE\n              ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                UPDATE\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CANCEL\n              ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "disbursmentModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(15), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createDisbursement()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(16), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.disbursementDate),
      expression: "form.disbursementDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'disbursementDate'
      ),
    },
    attrs: {
      "type": "date",
      "name": "disbursementDate",
      "placeholder": "Enter joining Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.disbursementDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "disbursementDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "disbursementDate"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.disbursement_id),
      expression: "form.disbursement_id"
    }],
    attrs: {
      "type": "hidden",
      "name": "disbursement_id"
    },
    domProps: {
      "value": (_vm.form.disbursement_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "disbursement_id", $event.target.value)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(17), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.emiStartDate),
      expression: "form.emiStartDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('emiStartDate'),
    },
    attrs: {
      "type": "date",
      "name": "emiStartDate",
      "placeholder": "Enter joining Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.emiStartDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "emiStartDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "emiStartDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Ledger Account ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_ledger_id),
      expression: "form.branch_ledger_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_ledger_id'),
    },
    attrs: {
      "name": "branch_ledger_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_ledger_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_ledger_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                              Select Ledger Account\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bank_accounts), function(bank_account) {
    return _c('option', {
      key: bank_account.id,
      domProps: {
        "value": bank_account.id
      }
    }, [_vm._v("\n                              " + _vm._s(bank_account.name) + " " + _vm._s(bank_account.remark) + "\n                            ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_ledger_id"
    }
  })], 1)])])])])]), _vm._v(" "), _vm._m(18)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "fileChargeModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(19), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.fileChargeProcessingFeeCollect()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Ledger Account ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_ledger_id),
      expression: "form.branch_ledger_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_ledger_id'),
    },
    attrs: {
      "name": "branch_ledger_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_ledger_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_ledger_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                              Select Ledger Account\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bank_accounts), function(bank_account) {
    return _c('option', {
      key: bank_account.id,
      domProps: {
        "value": bank_account.id
      }
    }, [_vm._v("\n                              " + _vm._s(bank_account.name) + " " + _vm._s(bank_account.remark) + "\n                            ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_ledger_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(20), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentDate),
      expression: "form.paymentDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'paymentDate'
      ),
    },
    attrs: {
      "type": "date",
      "name": "paymentDate",
      "placeholder": "Enter Payment Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.paymentDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "paymentDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Collect File Charge ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.amt),
      expression: "form.amt"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'amt'
      ),
    },
    attrs: {
      "type": "text",
      "name": "amt",
      "placeholder": "Please Enter amt",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.form.amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "amt"
    }
  })], 1)])])])])]), _vm._v(" "), _vm._m(21)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "processingFeeModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(22), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.fileChargeProcessingFeeCollect()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Ledger Account ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_ledger_id),
      expression: "form.branch_ledger_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_ledger_id'),
    },
    attrs: {
      "name": "branch_ledger_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_ledger_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_ledger_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                              Select Ledger Account\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bank_accounts), function(bank_account) {
    return _c('option', {
      key: bank_account.id,
      domProps: {
        "value": bank_account.id
      }
    }, [_vm._v("\n                              " + _vm._s(bank_account.name) + " " + _vm._s(bank_account.remark) + "\n                            ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_ledger_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(23), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentDate),
      expression: "form.paymentDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'paymentDate'
      ),
    },
    attrs: {
      "type": "date",
      "name": "paymentDate",
      "placeholder": "Enter Payment Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.paymentDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "paymentDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Collect Processing Fee ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.amt),
      expression: "form.amt"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'amt'
      ),
    },
    attrs: {
      "type": "text",
      "name": "amt",
      "placeholder": "Please Enter amt",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.form.amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "amt"
    }
  })], 1)])])])])]), _vm._v(" "), _vm._m(24)])])])]), _vm._v(" "), _c('view-loan-plan', {
    attrs: {
      "seeRecord": this.seeRecord,
      "pl": this.pl,
      "memberDetail": this.memberDetail,
      "getCompanyRecord": this.getCompanyRecord,
      "logo": this.logo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(25), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [(_vm.seeRecord.branch) ? _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Branch Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.branch.name))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Branch Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.branch.branchCode))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Agent Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.agent.name))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Agent Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.agent.code))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Plan Details")]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-striped table-dark"
  }, [_c('tr', [_c('td', [_c('b', [_vm._v("Plan Name ")]), _vm._v(" : " + _vm._s(_vm.pl.name))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Plan Type ")]), _vm._v(" : " + _vm._s(_vm.pl.planType))])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Type of Interest")]), _vm._v(" : " + _vm._s(_vm.pl.typeOfInterest) + "\n                            ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Recovery Type")]), _vm._v(" : " + _vm._s(_vm.pl.recoveryType) + "\n                            ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Number of Payments")]), _vm._v(" :\n                              " + _vm._s(_vm.pl.noOfPayments) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Amount")]), _vm._v(" : " + _vm._s(_vm.pl.amount))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Advance Installment")]), _vm._v(" :\n                              " + _vm._s(_vm.pl.acvanceInstallment) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Panulty ")]), _vm._v(": " + _vm._s(_vm.pl.panulty))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Processing Fee ")]), _vm._v(": " + _vm._s(_vm.pl.processingFee) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("File Charge")]), _vm._v(" : " + _vm._s(_vm.pl.fileCharge))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Created By")]), _vm._v(" : " + _vm._s(_vm.pl.created_by.name) + "\n                            ")])])])]), _vm._v(" "), (_vm.seeRecord.member_id) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Member Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.member.name))])]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [(_vm.seeRecord.branch) ? _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Plan Type")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.planType))])]), _vm._v(" "), (_vm.seeRecord.collection_center) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Group Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.collection_center.name))])]) : _vm._e(), _vm._v(" "), (_vm.seeRecord.collection_center) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Group Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.collection_center.centerCode))])]) : _vm._e(), _vm._v(" "), (_vm.seeRecord.collection_center_leader) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Group Leader")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.collection_center_leader.name))])]) : _vm._e(), _vm._v(" "), (_vm.seeRecord.collection_center_leader) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Group Leader Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.collection_center_leader.code))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Disbursement Date")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.disbursementDate))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("EMI Start Date")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.emiStartDate))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Payment Mode")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.paymentMode))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Status")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.status))])])]) : _vm._e()])])])])]), _vm._v(" "), _vm._m(26)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewGroupMember"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(27), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(28), _vm._v(" "), _c('tbody', [(_vm.groupmem) ? _c('tr', [_c('td', [_vm._v("\n                              " + _vm._s(_vm.groupmem.fatherName) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(_vm.groupmem.address) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(_vm.groupmem.city) + "\n                            ")])]) : _vm._e()])])])])])])])]), _vm._v(" "), _vm._m(29)])])]), _vm._v(" "), _c('demandprobeshnarynote', {
    attrs: {
      "seeRecord": _vm.seeRecord,
      "getCompanyRecord": _vm.getCompanyRecord,
      "logo": _vm.logo,
      "pl": _vm.pl,
      "mem": _vm.mem
    }
  }), _vm._v(" "), _c('printviewdisbursementcollectioncenterwise', {
    attrs: {
      "seeRecords": this.seeRecords,
      "branch": _vm.branch,
      "collectionCenter": _vm.collectionCenter,
      "getCompanyRecord": _vm.getCompanyRecord,
      "logo": _vm.logo
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Sr.")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pl Name")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pl Emi Type")]), _vm._v(" "), _c('th', [_vm._v("Pay Amt")]), _vm._v(" "), _c('th', [_vm._v("Member")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Mem Code")]), _vm._v(" "), _c('th', [_vm._v("Group")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Staff")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Branch Name")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Branch code")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Center Leader")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Branch "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Agent ID "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Group Leader "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Purpose "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Plan "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Description"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Loan Amount Type "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Member "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Loan Amount "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("File Charge Amount "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Processing Fee Amount "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Processing Fee Amount %"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Disbursement Loan")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Disbursement Date\n                            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("EMI Start Date "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                DISBURSEMENT\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CANCEL\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("File Charge")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Payment Date\n                            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                COLLECT\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CANCEL\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Processing Fee Charge")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Payment Date\n                            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                COLLECT\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CANCEL\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Loan Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              CLOSE\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Group Member Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("C/O")]), _vm._v(" "), _c('th', [_vm._v("Address")]), _vm._v(" "), _c('th', [_vm._v("City")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              CLOSE\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-df975ac2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/Loan/GroupLoan.vue
// module id = 823
// module chunks = 0